import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState, useCallback } from 'react';
import { useKeyPress } from './useKeyPress.js';
export function useKeyActive(ref, targetKeys = ['Enter', ' ']) {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isKeyActive = _useState2[0],
    setIsKeyActive = _useState2[1];
  const handleKeyActive = useCallback((event, isKeyDown) => {
    if (isKeyDown) {
      setIsKeyActive(true);
    } else {
      setIsKeyActive(false);
    }
  }, []);
  useKeyPress(ref, targetKeys, handleKeyActive);
  return isKeyActive;
}